// extracted by mini-css-extract-plugin
module.exports = {"Container":"spinner_Container__1PiXV","LoadingSpinner":"spinner_LoadingSpinner__XZ-Rn","spinner":"spinner_spinner__2I-yN"};